import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "isBestForDentistry",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
